module.exports = __webpack_public_path__ + "img/quarterOne.be7561ba.png";